function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M226.8 113.3l56.7-70.8H250L262.2 0l-56.7 70.8h33.4l-12.1 42.5zM201.6 148.9l-42-91.9.1-.2h38.7V28.3H56.6V0H28.1v28.3H0v28.5h28.1v226.7h28.5V56.8h86.9l.1.3-40.9 91.8h-3.5v85h106.3v-85h-3.9zm-49.9-74.3l34 74.3h-67l33-74.3zm11 88.9v55.8h-20.8v-55.8h20.8zm-48.8 0h13.4v55.8h-13.4v-55.8zm77.1 55.8h-13.8v-55.8H191v55.8z"
})));